<template>
    <div>
        <el-form-item label="平台来源：" prop="source_id" :rules="{ required: true, message: '平台来源不能为空', trigger: 'blur'}">
            <el-select v-model="query.source_id" filterable collapse-tags clearable @change="getSourceId" placeholder="平台来源" class="handle-select mr10 find-top">
                <el-option v-for="(row, index) in pickers.sourceList" :key="index" :label="row.title" :value="row.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="平台区域：" prop="account_city_id" :rules="{ required: true, message: '平台区域不能为空', trigger: 'blur'}" v-if="sourceAccount.accountCity.length && !showCity">
            <el-select v-model="query.account_city_id" filterable collapse-tags clearable @change="changeAccountCity" placeholder="区域" class="handle-select mr10 find-top">
                <el-option v-for="(row, index) in sourceAccount.accountCity" :key="index" :label="dictionary.getRegionItem(row, '无')" :value="row"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="平台账户：" prop="account_id" :rules="{ required: true, message: '平台账户不能为空', trigger: 'blur'}" v-if="sourceAccount.accountList.length">
            <el-select v-model="query.account_id" filterable collapse-tags clearable placeholder="账户" class="handle-select mr10 find-top">
                <el-option v-for="(row, index) in sourceAccount.accountList" :key="index" :label="row.title" :value="row.id"></el-option>
            </el-select>
        </el-form-item>
    </div>
</template>
<script>
import dictionary from '@/utils/dictionary.js';
export default {
    props: {
        query: {},
    },
    data() {
        let accountPickerList = dictionary.getPicker('account');
        return {
            allocateList: [],
            sourceAccount: {
                accountCity: [], //来源区域
                accountList: [], //来源账户
            },
            dialogVisible: false,
            accountPickerList: accountPickerList, //从本地获取的账号列表
            pickers: {
                // statusList: [],
                staffList: [],
                newsTypeList: [],
                sourceList: [],
                cityList: [],
                hotelList: [],
                allocateTypeList: [],
            },
        };
    },
    watch: {
        query: function (newVal, oldVal) {
            console.log(newVal)
        }
    },
    beforeMount() {
        this.dictionary = dictionary;
    },
    created() {
        this.getPickerList();
        this.getSourceId(this.query.source_id)

    },
    methods: {
        // 获取下拉列表
        getPickerList() {
            let _this = this;
            let url = '/api/customer.picker/items';
            this.$post(url, {}).then(function (response) {
                let result = response.data;

                _this.pickers.sourceList = result.sourceList.filter((item) => item.is_valid == 1);
                _this.pickers.newsTypeList = result.newsTypeList;
                _this.pickers.cityList = result.cityList;
                _this.pickers.hotelList = result.storeList;
                _this.pickers.allocateTypeList = result.allocateTypeList;
                _this.pickers.statusList = result.statusList;
                _this.pickers.staffList = result.staffList;
                // that.callRecord = result.callRecord;
            });
        },
        // 选择来源
        getSourceId(id) {
            this.query.source_id = id;
            this.query.account_city_id = '';
            this.query.account_id = '';
            this.sourceAccount.accountCity = [];
            this.sourceAccount.accountList = [];
            this.showCity = false;
            let accountSourceList = [];
            let cityArr = [];
            this.accountPickerList.forEach((item, index) => {
                if (item.source_id == id) {
                    accountSourceList.push(item);
                }
            });
            this.accountSourceList = accountSourceList;
            this.accountSourceList.forEach((item, index) => {
                cityArr.push(item.city_id);
            });
            // 城市去重
            cityArr.sort();
            let newCityArr = [cityArr[0]];
            for (var i = 0; i < cityArr.length; i++) {
                if (cityArr[i] !== newCityArr[newCityArr.length - 1]) {
                    newCityArr.push(cityArr[i]);
                }
            }
            this.sourceAccount.accountCity = newCityArr;
            // 没有区域直接选账号
            if (this.sourceAccount.accountCity.length == 1 && this.sourceAccount.accountCity[0] == 0) {
                this.sourceAccount.accountList = this.accountSourceList;
                if (this.sourceAccount.accountList.length) {
                    this.showCity = true;
                }
            }
            // 区域只有无并且无匹配账号
            if (this.sourceAccount.accountCity.length == 1 && !this.sourceAccount.accountCity[0] && !this
                .sourceAccount.accountList.length) {
                this.showCity = true;
            }
        },
        // 来源城市匹配账号
        changeAccountCity(id) {
            this.query.account_city_id = id;
            this.query.account_id = '';
            let accountList = [];
            accountList = this.accountSourceList.filter(item => item.city_id == id && item.source_id == this.query
                .source_id);
            this.sourceAccount.accountList = accountList;
        },

    }
};
</script>
<style scoped>
.find-top{
  padding: 0;
  margin: 0;
}
</style>